(function() {
  // Solo activar en ordenadores (sin pantallas táctiles)
  const isDesktop = window.matchMedia("(min-width: 1025px)").matches && !('ontouchstart' in window);

  if (!isDesktop) {
    return; // En móviles/tablets no se activa
  }

  document.addEventListener("mousemove", function(e) {
    let trail = document.createElement("span");
    trail.innerHTML = "💤"; 
    trail.style.position = "fixed";
    trail.style.left = e.clientX + "px";
    trail.style.top = e.clientY + "px";
    trail.style.pointerEvents = "none";
    trail.style.fontSize = Math.random() * 20 + 20 + "px"; // tamaño aleatorio
    trail.style.opacity = "1";
    trail.style.transition = "transform 1s ease-out, opacity 1s ease-out";
    trail.style.zIndex = "9999"; // siempre encima

    document.body.appendChild(trail);

    // Animación (sube y rota)
    setTimeout(() => {
      trail.style.transform = "translateY(-40px) rotate(" + (Math.random() * 60 - 30) + "deg)";
      trail.style.opacity = "0";
    }, 50);

    // Eliminar después de animación
    setTimeout(() => {
      trail.remove();
    }, 1200);
  });
})();
